import React from "react";
import type { ViewComponent } from "@frui.ts/views/dist";
import { registerView } from "@frui.ts/views/dist";
import { observer } from "mobx-react-lite";
import CreditExposureCreateViewModel from "viewModels/timeCharges/distributors/creditExposures/creditExposureCreateViewModel";
import CreateView from "../../../common/create";
import CreditExposureForm from "./creditExposureForm";
import { Modal } from "react-bootstrap";

const CreditExposureCreateView: ViewComponent<CreditExposureCreateViewModel> = observer(({ vm }) => (
  <Modal scrollable show={true} onHide={vm.requestClose} centered>
    <Modal.Body>
      <CreateView vm={vm} titleClassName="text-left" form={<CreditExposureForm vm={vm} />} />
    </Modal.Body>
  </Modal>
));

registerView(CreditExposureCreateView, CreditExposureCreateViewModel);
